import { createContext } from 'react';

export const DefinitionContext = createContext({
  definitions: { data: [], enabledStatus: false },
  updateDefinitions: () => {},
});
